import { options } from '@master/model/options/Options'

export const WrapList = ['Wrap', 'Non-wrap', 'Not Applicable'] as const
export const WrapOptions: options[] = WrapList.map(wrap => {
  return {
    label: wrap,
    value: wrap
  }
})
